import { merge } from 'lodash';

export const initialState = {
    userProfile: null,
    originalUserProfile: null,
    notificationPreferences: null,
    originalNotificationPreferences: null,
    appointmentPreferences: null,
    originalAppointmentPreferences: null,
    toastText: '',
    showToast: false,
    showCancelDialog: false
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_USER_PROFILE':
            // While the backend defaults to an empty string for correspondenceTo, it still treats that empty/null
            // value as if it were set to SCHOOL_MAIL. To avoid confusion for the end user, we want to indicate that
            // they will get/have been getting emails to their institution email by checking the "notifications to 
            // institution email" checkbox.
            const profile = merge({
                correspondenceTo: 'SCHOOL_MAIL'
            }, action.elements);
            // An empty string does not get overridden by merge so we need to set the default here as well.
            if (profile.correspondenceTo === '') profile.correspondenceTo = 'SCHOOL_MAIL';
            return {
                ...state,
                userProfile: profile,
                originalUserProfile: profile
            };
        case 'LOAD_NOTIFICATION_PREFERENCES':
            return {
                ...state,
                notificationPreferences: action.elements,
                originalNotificationPreferences: action.elements
            };
        case 'LOAD_APPOINTMENT_PREFERENCES':
            // This needs to be done, since the backend does not return any default value for these(if not set),
            // but front end expects them
            const appointmentPrefs = merge({
                deadLineValue: {
                    HOURS_BEFORE: 1,
                    ON_DAY: "9:00 AM",
                    DAY_BEFORE: "5:00 PM"
                }
            }, action.elements);
            return {
                ...state,
                appointmentPreferences: appointmentPrefs,
                originalAppointmentPreferences: appointmentPrefs
            };
        case 'SET_VALUE':
            return merge({}, state, action.elements);
        case 'RESET_CHANGES':
            return {
                ...state,
                userProfile: state.originalUserProfile,
                notificationPreferences: state.originalNotificationPreferences,
                appointmentPreferences: state.originalAppointmentPreferences,
                toastText: 'Your changes have been cleared.',
                showToast: true,
                showCancelDialog: false
            };
        case 'CHANGES_SAVED':
            return {
                ...state,
                originalUserProfile: state.userProfile,
                originalNotificationPreferences: state.notificationPreferences,
                originalAppointmentPreferences: state.appointmentPreferences,
                toastText: 'Your changes have been saved.',
                showToast: true
            };
        case 'HIDE_TOAST':
            return {
                ...state,
                showToast: false
            };
        case 'SHOW_CANCEL_DIALOG':
            return {
                ...state,
                showCancelDialog: true
            }; 
        case 'HIDE_CANCEL_DIALOG':
            return {
                ...state,
                showCancelDialog: false
            };
        case 'EXCHANGE_SYNC':
            const updatedExchangeImpersonationPreference = {
                exchangeImpersonationStatus: action.elements.exchangeImpersonationStatus,
                exchangeImpersonationEnabled: action.elements.exchangeImpersonationEnabled,
                exchangeFreeBusyEnabled: action.elements.exchangeFreeBusyEnabled
            };
            return {
                ...state,
                notificationPreferences: {...state.notificationPreferences, ...updatedExchangeImpersonationPreference},
                originalNotificationPreferences: {...state.originalNotificationPreferences, ...updatedExchangeImpersonationPreference},
                toastText: 'Your outlook calendar preferences have been updated.',
                showToast: true
            };
    }
};
